<template>
  <div
    v-if="banners.length"
    class="tw-bg-white tw-rounded-lg tw-border tw-border-dashed tw-border-emerald-300 tw-p-4 tw-flex tw-items-center tw-justify-center tw-overflow-hidden"
  >
    <transition
      name="banner-fade"
      mode="out-in"
    >
      <img
        :key="currentIndex"
        :src="banners[currentIndex]"
        :alt="alt"
        class="tw-w-full tw-max-h-48 tw-object-contain tw-rounded-md tw-bg-slate-50"
        loading="lazy"
      >
    </transition>
  </div>
</template>

<script>
import { ref, watch, onBeforeUnmount, computed } from 'vue'

export default {
  name: 'PromotionalBanners',
  props: {
    banners: {
      type: Array,
      default: () => []
    },
    alt: {
      type: String,
      default: 'Promotional banner'
    },
    intervalMs: {
      type: Number,
      default: 5000
    }
  },
  setup(props) {
    const currentIndex = ref(0)
    let timer = null

    const bannerCount = computed(() => props.banners.length)

    const stopTimer = () => {
      if (timer) {
        clearInterval(timer)
        timer = null
      }
    }

    const startTimer = () => {
      stopTimer()
      if (bannerCount.value > 1) {
        timer = setInterval(() => {
          currentIndex.value = (currentIndex.value + 1) % bannerCount.value
        }, props.intervalMs)
      }
    }

    watch(
      () => props.banners,
      () => {
        currentIndex.value = 0
        startTimer()
      },
      { immediate: true, deep: true }
    )

    watch(() => props.intervalMs, () => startTimer())

    onBeforeUnmount(stopTimer)

    return {
      currentIndex
    }
  }
}
</script>

<style scoped>
.banner-fade-enter-active,
.banner-fade-leave-active {
  transition: opacity 0.5s ease;
}
.banner-fade-enter-from,
.banner-fade-leave-to {
  opacity: 0;
}
</style>
